import React from 'react';
import { Link } from 'react-router-dom';

const BackButton = ({ location, label = 'Back' }: { location?: string; label?: string }) => (
   <Link to={location || '../'} className="group inline-flex items-center gap-3 py-2">
      <span className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 transition-colors duration-300 group-hover:border-signal group-hover:bg-signal group-hover:text-ink-950">
         <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M7.5 2L3.5 6l4 4" stroke="currentColor" strokeWidth="1.3" />
         </svg>
      </span>
      <span className="eyebrow transition-colors group-hover:text-bone">{label}</span>
   </Link>
);

export default BackButton;
